import axios from "axios";
import {Base_URL} from "../url"

export const fetchApprovalData = async (id) => {
    try {
      const response = await axios.get(`${Base_URL}/ApprovalExpenses/ApprovalData/id?id=${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching approval data:", error);
      throw error;
    }
  };
  
  // Send Approval Request (Only Sends Data, No Frontend Update)
  export const sendApprovalRequest = async (expenseId) => {
    try {
      await axios.put(`${Base_URL}/ApprovalExpenses/UpdateAproval?ExpensesId=${expenseId}`);
    } catch (error) {
      console.error("Error sending approval request:", error);
      throw error;
    }
  };
   export const sendPayRequest = async (expenseId) => {
    try {
      await axios.put(`${Base_URL}/ApprovalExpenses/UpdatePayStatus/${expenseId}`);
    } catch (error) {
      console.error("Error sending approval request:", error);
      throw error;
    }
  };